import { apiRequest } from 'utils/request'

export const savePtoTemplate = ({
  templateId,
  name,
  notes,
  description,
  fragments,
}) =>
  apiRequest({
    uri: `pto-templates/${templateId}/update`,
    method: 'POST',
    body: {
      name,
      description,
      notes,
      fragments,
    },
  })
